import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button3D from '../shared/Button3D';

export default function GetYourSwag() {
  return (
    <Box bgcolor="#F2E8E3">
      <Container sx={{ py: 10 }}>
        <Stack alignItems="center">
          <Typography variant="h4" mb={3} width={{ xs: '100%', sm: '80%', md: '60%' }} textAlign="center">
            Get Your Swag On With SwagCharm!
          </Typography>

          <Typography
            variant="subtitle1"
            mb={3}
            width={{ xs: '100%', sm: '80%', md: '50%' }}
            mx="auto"
            textAlign="center"
          >
            Share your company spirit by delivering custom-made Swag Packs to anyone worldwide.
          </Typography>

          <Button3D href="/shop" maxWidth={170}>
            Shop Swag Now
          </Button3D>
        </Stack>
      </Container>
    </Box>
  );
}
